export enum COMMUNITY_QUERY_RESULT {
  /** 未搜尋 */
  UNSEARCH = 'unsearch',
  /** 等待查詢中 */
  PENDING = 'pending',
  /** 關鍵字查詢結果過多 */
  MULTIPLE = 'multiple',
  /** 無相關關鍵字社區 */
  NOT_FOUND = 'not_found',
  /** 查詢成功 */
  SUCCESS = 'success'
}
